import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dipartimentoPipe' })
export class DipartimentoPipe implements PipeTransform {

    transform(inputValue: number): string {

        var rispostaAlPipe = "Valore inesistente";


        switch(inputValue){

            case 1:
            {
                rispostaAlPipe = "DIGIU";
            }
            break;

            case 2:
            {
                rispostaAlPipe = "DIING";
            }
            break;

            case 3:
            {
                rispostaAlPipe = "DISET";
            }
            break;

            case 4:
            {
                rispostaAlPipe = "DSMEB";
            }
            break;

            case 5:
            {
                rispostaAlPipe = "DISAQ";
            }
            break;

            case 6:
            {
                rispostaAlPipe = "DISAE";
            }
            break;

            case 7:
            {
                rispostaAlPipe = "DISEG";
            }
            break;

        }

        return rispostaAlPipe;

    }

}